module.exports = __webpack_public_path__ + "static/topvideo-e050811c6690025c1a3ff0af1777117d.mp4";